document.addEventListener('change', function (e) {
  if (!e.target.closest('.filter-form')) return;

  const form = e.target.closest('.filter-form');
  const formData = new FormData(form);
  const params = new URLSearchParams(formData).toString();

  // IMPORTANT: section id (check your theme)
  const section = document.querySelector('[data-section-id]');
  const sectionId = section ? section.dataset.sectionId : null;

  if (!sectionId) return;

  const url = `${window.location.pathname}?section_id=${sectionId}&${params}`;

  document.querySelector('#CollectionProductGrid').classList.add('loading');

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      // Replace full section (best for Impulse)
      const newSection = temp.querySelector('[data-section-id]');
      const currentSection = document.querySelector('[data-section-id]');

      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;
      }

      // Update URL
      window.history.pushState({}, '', window.location.pathname + '?' + params);
    })
    .finally(() => {
      document.querySelector('#CollectionProductGrid').classList.remove('loading');
    });
});


// product page
// Remove default selection on load
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.variant-input').forEach(el => {
    el.classList.remove('is-selected');
    el.checked = false;
  });
});

// ================
document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('[name="add"]');
  const buttonText = document.querySelector('[data-add-to-cart-text]');

  const defaultText = "Add to cart";
  const selectText = "Choose variant option";

  if (!button) return;

  // Check if variant selectors exist
  const variantInputs = document.querySelectorAll('.variant-input, .variant__button');

  // If variants exist → disable button initially
  if (variantInputs.length > 0) {
    button.setAttribute('disabled', true);

    if (buttonText) {
      buttonText.innerText = selectText;
    }
  } 
  // If no variants → keep Add to Cart enabled
  else {
    button.removeAttribute('disabled');

    if (buttonText) {
      buttonText.innerText = defaultText;
    }
  }

  // Enable on variant change
  document.addEventListener('variant:change', function (event) {
    if (event.detail.variant) {
      button.removeAttribute('disabled');

      if (buttonText) {
        buttonText.innerText = defaultText;
      }
    }
  });

  // Enable on click (same variant case)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.variant-input, .variant__button')) {
      setTimeout(() => {
        button.removeAttribute('disabled');

        if (buttonText) {
          buttonText.innerText = defaultText;
        }
      }, 100);
    }
  });
});

// =======================

document.addEventListener('DOMContentLoaded', function () {
  const variantGroups = document.querySelectorAll('.variant-input');

  variantGroups.forEach(group => {
    const radios = group.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.checked = false;
    });
  });
});

// image zoom js

document.addEventListener("DOMContentLoaded", function () {
  const scrollTopBtn = document.getElementById("scrollTopBtn");

  // Show button only after scrolling down
  window.addEventListener("scroll", function () {
    if (window.scrollY > 200) {
      scrollTopBtn.classList.add("show");
    } else {
      scrollTopBtn.classList.remove("show");
    }
  });

  // Scroll to top on click
  scrollTopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});


// website cookies

document.addEventListener("DOMContentLoaded", function () {
  const banner = document.getElementById("cookie-banner");
  const acceptBtn = document.getElementById("accept-cookies");
  const declineBtn = document.getElementById("decline-cookies");

  // Show banner only if not already accepted
  if (!localStorage.getItem("cookie_consent")) {
    banner.style.display = "block";
  }

  acceptBtn.addEventListener("click", function () {
    localStorage.setItem("cookie_consent", "accepted");
    banner.style.display = "none";
  });

  declineBtn.addEventListener("click", function () {
    localStorage.setItem("cookie_consent", "declined");
    banner.style.display = "none";
  });
});

// sticky  product
document.addEventListener('DOMContentLoaded', function () {
  const bar = document.getElementById('sticky-atc-bar');
  const btn = document.getElementById('sticky-add-to-cart');
  const qty = document.getElementById('sticky-qty');
  const variantId = document.getElementById('sticky-variant-id');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 400) {
      bar.style.display = 'block';
    } else {
      bar.style.display = 'none';
    }
  });

  btn.addEventListener('click', function () {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId.value,
        quantity: parseInt(qty.value)
      })
    })
    .then(res => res.json())
    .then(data => {
      // Open cart drawer (Impulse compatible)
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: data }));
    })
    .catch(err => console.log(err));
  });
});